import { render, staticRenderFns } from "./InspectionForm2.vue?vue&type=template&id=04570d74&scoped=true"
import script from "./InspectionForm2.vue?vue&type=script&lang=js"
export * from "./InspectionForm2.vue?vue&type=script&lang=js"
import style0 from "./InspectionForm2.vue?vue&type=style&index=0&id=04570d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04570d74",
  null
  
)

export default component.exports